<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/rectifyTarget' }">目标整改</el-breadcrumb-item>
        <el-breadcrumb-item>目标整改详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox content">
      <!-- <el-divider><span style="font-size: 18px;color: #666666">详情</span></el-divider> -->
      <div style="width: 80%;margin: auto">
        <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">基础信息</span></el-divider></div>
        <div class="detailBox">
          <div>
            目标指标编号：
            <span>{{ obj.indicatorNumber }}</span>
          </div>
          <div>
            复核部门：
            <span>{{ obj.reCheckDepName }}</span>
          </div>
          <div>
            整改部门：
            <span>{{ obj.abarbeitungDepName }}</span>
          </div>
          <!-- <div>
            指标级别：
            <span>{{ levelList[obj.companyLeaderEmpid - 1] }}</span>
          </div> -->
          <div>
            复核负责人：
            <span>{{ obj.reCheckEmpName }}</span>
          </div>
          <div>
            整改负责人：
            <span>{{ obj.abarbeitungDutyName }}</span>
          </div>
          <div>
            复核时间：
            <span>{{ obj.abarbeitungCompletionTime | timeFilter }}</span>
          </div>
          <div>
            整改期限：
            <span>{{ obj.abarbeitungCompletionTime | timeFilter }}</span>
          </div>
          <div>
            复核状态：
            <span v-if="obj.status === 0">待复核</span>
            <span v-if="obj.status === 1">合格</span>
            <span v-if="obj.status === 2">不合格</span>
          </div>
        </div>
        <div class="tableBox">
          <div style="margin: 50px 0"><el-divider content-position="left"><span style="color: 666666; font-size: 16px">考核内容</span></el-divider></div>
          <div class="a" style="margin-top: 30px">
            整改内容：
            <span><pre>{{ obj.abarbeitungContent }}</pre></span>
          </div>
          <div class="a">
            复核内容：
            <span><pre>{{ obj.reCheckContent }}</pre></span>
          </div>
          <div class="a">
            附件：
            <el-link type="primary" @click="downLoad(obj.fileUrl, obj.fileName)">{{ obj.fileName }}</el-link>
          </div>
          <div class="a">
            备注：
            <span><pre>{{ obj.postscript }}</pre></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rectifyDetail, examineSplit } from "@/api/processManager";
import { downLoadDocument } from "@/api/downLoad"
export default {
  name: "standardDetail",
  data() {
    return {
      obj: {},
      tableData: [],
      typeList: ['年度目标','季度目标','月度目标'],
      levelList: ['公司级','部门级'],
      form: {
        id: '',
        pass: 0,
        auditContent: ''
      },
    };
  },
  created() {
    this.form.id = this.$route.params.id
    this.getDetail();
  },
  methods: {
    getDetail() {
      rectifyDetail(this.$route.params.id).then(res => {
        this.obj = res.body.data;
      });
    },
    // 下载文件
    downLoad(url, name) {
      downLoadDocument(url, name)
    }
  }
};
</script>

<style scoped>
.innerBox {
  width: 100%;
  height: 100%;
  background: white;
}
.detailBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.detailBox div {
  width: 50%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.tableBox {
  margin-top: 15px;
}
.tableBox .tableBoxTitle {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.a {
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  color: #555555;
}
.detailBox > div > span {
  color: #888888;
}
.a > span {
  color: #888888;
}
.innerBox .el-form-item {
  margin-bottom: 5px;
}
pre {
  line-height: 20px;
  font-size: 16px;
  display: inline-block;
  vertical-align: top;
  margin-top: 10px
}
</style>